import store from '../../di/store';
import { IActionCreator } from '../../utils/fsa';
import { IActionUserClaimsData } from './action_creators/user_claims';
import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

type TUserClaimsAction = IActionCreator<IActionUserClaimsData, IActionUserClaimsData>;
function loadComponents(): Promise<{
  // tslint:disable-next-line:no-any
  UserClaimsButtonContainer: any;
  setUserClaimsData: TUserClaimsAction;
}> {
  return new Promise((resolve, reject) => {
    require.ensure([
      './components/user_claims_button/user_claims_button_container',
      './action_creators/user_claims',
    ], () => {
      resolve({
        UserClaimsButtonContainer: require('./components/user_claims_button/user_claims_button_container').default,
        setUserClaimsData: require('./action_creators/user_claims').setUserClaimsData,
      });
    });
  });
}

export default function initUserClaims() {
  // tslint:disable-next-line:no-any
  (window as any).renderUserClaims = (element: Element, options: IActionUserClaimsData) => {
    loadComponents()
      .then(({ UserClaimsButtonContainer, setUserClaimsData }) => {
        store.dispatch(setUserClaimsData(options));

        render(
          <Provider store={store}>
            <UserClaimsButtonContainer />
          </Provider>,
          element
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/bundles/user_claims/index.tsx